import React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <h1>{`Zapraszam`}</h1>
    <p>{`kom `}<strong parentName="p">{`+48 608 77 44 11`}</strong><br />{`
tel +48 81 525 99 06`}<br />{`
fax +48 81 525 23 22`}<br /></p>
    <p>{`grzegorz `}{`[MAŁPA]`}{` sadura `}{`[KROPKA PL]`}<br />{`
biuro `}{`[MAŁPA]`}{` sadura `}{`[KROPKA PL]`}<br /></p>
    <p>{`NIP: 712-109-39-03`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      